import {createContext} from '@lit-labs/context';
import type {Policies} from '@gl/lit/types/audiences.js';

export const audiencePolicyContext =
  createContext<Policies>('audience-policies');
